const GET_MYLIST = 'flixfrenzy/redux/GET_MYLIST';
const ADD_MYLIST = 'flixfrenzy/redux/ADD_MYLIST';
const REMOVE_MYLIST = 'flixfrenzy/redux/REMOVE_MYLIST';

const initialState = {
  allMyList: [],
};

let myState;

// eslint-disable-next-line default-param-last
const myListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MYLIST:
      myState = state;
      return action.payload;
    case ADD_MYLIST:
      // myState = state;
      return { ...state, allMyList: [...state.allMyList, action.payload] };
    case REMOVE_MYLIST:
      return { ...state, allMyList: state.allMyList.filter((list) => list !== action.payload) };
    default:
      myState = state;
      return state;
  }
};

export const getMyList = () => (dispatch) => {
  dispatch({
    type: GET_MYLIST,
    payload: myState,
  });
};

export const addMyList = (movie) => (dispatch) => {
  dispatch({
    type: ADD_MYLIST,
    payload: movie,
  });
};

export const removeMyList = (movie) => (dispatch) => {
  dispatch({
    type: REMOVE_MYLIST,
    payload: movie,
  });
};

export default myListReducer;
